<script lang="ts">
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';
	import { Text } from '@Shelly/shelly-design-system';
	import { openExternalLink } from 'src/helpers/utilities';

	const dispatch = createEventDispatcher();

	const url = 'https://www.verivox.de/?tunnel-partner5762';

	const handleClick = (event: MouseEvent) => {
		event.preventDefault();

		const eventDetail: { preventDefault?: boolean } = {};
		dispatch('click', eventDetail);

		if (eventDetail.preventDefault !== true) {
			openExternalLink(url);
		}
	};
</script>

<div class="attribution-footer">
	<Text styleType="body-extra-small" class="attribution-text">
		{$format('energy_price_data_source', {
			default: 'Ein Service von ',
			locale: 'de',
		})}
		{' '}
		<a
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			class="attribution-link"
			on:click|stopPropagation={handleClick}
		>
			verivox.de
		</a>
	</Text>
</div>

<style>
	.attribution-footer {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: 8px;
		padding-top: 0;
		border-top: none;
		position: relative;
		z-index: 1;
	}

	:global(.attribution-text) {
		opacity: 0.7;
		text-align: right;
		color: rgba(255, 255, 255, 0.8) !important;
		font-size: 9px;
		line-height: 1.3;
	}

	.attribution-link {
		color: rgba(255, 255, 255, 0.85);
		text-decoration: underline;
		cursor: pointer;
		margin: 0 2px;
		transition: opacity 0.2s ease;
	}

	.attribution-link:hover {
		opacity: 1;
		color: rgba(255, 255, 255, 0.95);
	}
</style>
